import React from 'react';
import type { RouteComponentProps } from 'react-router';

import Body from '@swf/components/StarsModal/components/Body';
import CloseButton from '@swf/components/StarsModal/components/CloseButton';
import Header from '@swf/components/StarsModal/components/Header/Header';

import styles from './CasinoRewardInfo.scss';

const CasinoRewardInfo: React.FC<
  RouteComponentProps<object, object, { title: string; message: string }>
> = ({
  location: {
    state: { title, message }
  }
}) => (
  <>
    <Header>
      {title}
      <CloseButton />
    </Header>
    <Body className={styles.body}>
      <p>{message}</p>
    </Body>
  </>
);

export default CasinoRewardInfo;
